module.exports = __webpack_public_path__ + "media/assets/images/logos/unox_logo-f3646309c308901a4d5390ccc1b3bc62.png";